/*@ngInject*/
const UserGroupActionsUtil = function ($rootScope, $stateParams, $state, $q, userGroupEditorModel, modalUtil,
                                       coreConstant, loadingBarHandler, userMediator) {

    this.createUserGroup = function (userGroupId, translations) {
        let userGroup = userGroupEditorModel.getUserGroup(userGroupId);
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'createUserGroup.loadingBar'));
        return userMediator.createUserGroup(userGroup).then((result) => {
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'createUserGroup.creatingUserGroupSuccessLoadingBar'));
            return result;
        });
    };

    this.saveUserGroup = function (userGroupId, translations) {
        let userGroup = userGroupEditorModel.getUserGroup(userGroupId);
        loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'saveUserGroup.loadingBar'));
        return userMediator.saveUserGroup(userGroup).then((result) => {
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'saveUserGroup.savingUserGroupSuccessLoadingBar'));
        });
    };

    this.discard = function (userGroupId, translations) {
        modalUtil.showConfirmationModal(null, null, null, 'userGroupEditorHeader.discardConfirmation', null, true, function () {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'discardConfirmation.success'));
            userGroupEditorModel.hasUnsavedChanges = false;
            if (!_.isNil(userGroupId) && userGroupId !== -1 && userGroupEditorModel.getUserGroup(userGroupId)) {
                $state.reload();
            } else {
                $state.go('userGroups', {});
            }
        });
    };

    this.delete = function (translations, sectionTemplateId) {
        //TBD
    };
};

angular.module('umCore')
    .service('userGroupActionsUtil', UserGroupActionsUtil);
